module.exports = __webpack_public_path__ + "static/media/atn.4efedc06.png";